
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { InnerMenuLiveProcessComponent } from './inner-menu-liveprocess.component';
import { LiveProcessComponent } from './components/liveprocess/liveprocess.component';
import { RedirectComponent } from '../shared/components/redirect/redirect.component';

export const InnerMenuLiveProcessRoutes: Routes = [
    {
        path: '',
        component: InnerMenuLiveProcessComponent,
        children: [
            {
                path: '',
                component: RedirectComponent
            },
            {
                path: 'process',
                component: LiveProcessComponent
            }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(InnerMenuLiveProcessRoutes)],
    exports: [RouterModule],
    providers: []
})
export class InnerMenuLiveProcessRoutingModule { }